import { useEffect, useState } from 'react';
import { useGetBonusGroup } from '@/query/queries/marketing/useGetBonusGroup';

// Hook to calculate bonus for allocation to GroupA. "Every 5 for 100"
export const useCalculateBonuses = (amount = 0, bonusAmount = 0) => {
  const [bonus, setBonus] = useState(0);

  const { data: bonusGroup } = useGetBonusGroup();

  useEffect(() => {
    if (bonusGroup) {
      const currentAmount = amount;
      const calculatedBonus =
        Math.max(
          parseInt(
            (currentAmount - bonusAmount) / bonusGroup.investment_amount,
          ),
          0,
        ) * bonusGroup.bonus_amount;
      setBonus(calculatedBonus);
    }
  }, [amount, bonusGroup, bonusAmount]);

  return { bonus };
};
